import React from 'react';
import PropTypes from 'prop-types';

import TextPropertiesSidebar from "./TextPropertiesSidebar";
import ImagePropertiesSidebar from "./ImagePropertiesSidebar";
import ElementPropertiesSidebarTray from "./ElementPropertiesSidebarTray";
import Sidebar from "Components/Sidebar";
import Arrangement from "Components/Properties/Arrangement";
import Placement from "Components/Properties/Placement";

const map = {
    "text": TextPropertiesSidebar,
    "image": ImagePropertiesSidebar
};

export default class ElementPropertiesSidebar extends React.Component
{
    static propTypes = {
        onChanged: PropTypes.func.isRequired,
        onChanging: PropTypes.func.isRequired,

        removeElement: PropTypes.func.isRequired,

        bringElementForward: PropTypes.func.isRequired,
        sendElementBackward: PropTypes.func.isRequired,
        bringElementToFront: PropTypes.func.isRequired,
        sendElementToBack: PropTypes.func.isRequired,
    };

    render()
    {
        const {element, media, ...actions} = this.props;

        const ElementSidebar = map[element.type];

        const tray = <ElementPropertiesSidebarTray element={element} {...actions} />;

        return <Sidebar tray={tray}>

            <div className='p-4 pb-0'>
                <Arrangement
                    bringElementForward={() => actions.bringElementForward(element.id)}
                    sendElementBackward={() => actions.sendElementBackward(element.id)}
                    bringElementToFront={() => actions.bringElementToFront(element.id)}
                    sendElementToBack={() => actions.sendElementToBack(element.id)}
                />
            </div>

            <div className='p-4'>
                <Placement
                    x={element.x}
                    y={element.y}
                    width={element.width}
                    height={element.height}
                    onChange={(key, value) => actions.onChanging(element.id, {[key]: value})}
                    onBlur={() => actions.onChanged(element.id)}
                />
            </div>

            <ElementSidebar element={element} media={media} {...actions} />
        </Sidebar>;
    }
}
